import { getExponent } from "@axisvue/utils";

function exponent(e) {
  return `x10${getExponent(Number(e))}`;
}

export default exponent;
